import { LIVE_CHAT_SOCKET_EVENTS } from "../constants";

let heartbeatSequence = 0;

export function createHeartbeat() {
  heartbeatSequence += 1;
  const clientEventId = `${Date.now()}-${heartbeatSequence}`;

  return {
    type: LIVE_CHAT_SOCKET_EVENTS.heartbeat,
    client_event_id: clientEventId,
    sent_at: new Date().toISOString(),
  };
}

export function isHeartbeatAck(payload, expectedHeartbeatId) {
  const acknowledgedId = payload?.client_event_id ?? payload?.data?.client_event_id;

  return (
    Boolean(expectedHeartbeatId) &&
    payload?.type === LIVE_CHAT_SOCKET_EVENTS.heartbeatAck &&
    typeof acknowledgedId === "string"
  );
}
